export function todoJobNo(row) {
  const source = row || {};
  return String(
    source['_jobNo'] ||
      source['Workshop Job No'] ||
      source['Job No.'] ||
      source['Job No'] ||
      source.JobNo ||
      source.jobno ||
      '',
  ).trim();
}

export function statusDisplay(status) {
  const normalizedStatus = String(status || '').trim();
  const tone = { Pending: 'warn', Completed: 'ok', Cancelled: 'neutral' }[normalizedStatus] || 'neutral';
  return `<span class="status-chip status-chip--${tone}">${normalizedStatus}</span>`;
}
export function normalizeRows(items, categoryDisplay = (value) => value) {
  if (!Array.isArray(items)) return [];
  return items.map((item, index) => {
    const source = item || {};
    const recordState =
      (
        String(source['_recordState'] || source.RecordState || 'A')
          .trim()
          .toUpperCase() == 'C'
      ) ?
        'C'
      : 'A';
    const completionDate = source['Completion Date'] || source.CompletionDate || source.completiondate || '';
    const status =
      recordState == 'C' ? 'Cancelled'
      : completionDate ? 'Completed'
      : 'Pending';
    const linkedJobNo = todoJobNo(source);
    const jobNoMissing = String(source['_jobNoMissing'] || source.JobNoMissing || '').trim() == '1';
    const vehicleNo = String(
      source['Vehicle No.'] || source['Inventory #'] || source.InventoryNo || source.inventoryno || '',
    ).trim();
    const vehicleCode = String(source['Vehicle Code'] || source['Inventory Code'] || source.InventoryCode || '').trim();
    const vehicleTeam = String(source['Vehicle Team'] || source.Team || '').trim();
    const vehicleCategory = categoryDisplay(String(source['Vehicle Category'] || source.Category || '').trim());
    const taskName = String(source['Task Name'] || source.TaskName || source.taskname || '').trim();
    const vehicleDisplay = `${vehicleNo}${vehicleCode ? ` - ${vehicleCode}` : ''}`;
    const workshopJobDisplay = jobNoMissing && linkedJobNo ? `${linkedJobNo} (Unavailable)` : linkedJobNo;
    const normalizedRow = {
      '#': index + 1,
      'Task Name': taskName,
      Vehicle: vehicleDisplay,
      'Date Created': source['Date Created'] || source.DateCreated || source.datecreated || '',
      'Due Date': source['Due Date'] || source.DueDate || source.duedate || '',
      Status: statusDisplay(status),
      _status: status,
      'Completion Date': completionDate,
      Remarks: String(source.Remarks || source.remarks || '').trim(),
      'Vehicle Team': vehicleTeam,
      'Vehicle Category': vehicleCategory,
      'Workshop Job No': workshopJobDisplay,
      'Todo ID': source['Todo ID'] || source.TodoID || source.todoid || '',
      'Vehicle No.': vehicleNo,
      'Vehicle Code': vehicleCode,
      'Job No.': workshopJobDisplay,
      'Vehicle Group': [
        `Vehicle: ${vehicleDisplay}`,
        vehicleCategory ? `Category: ${vehicleCategory}` : '',
        vehicleTeam ? `Team: ${vehicleTeam}` : '',
      ]
        .filter(Boolean)
        .join(', '),
      _rowid: source['_rowid'] || `row${index}`,
      _jobNo: linkedJobNo,
      _jobNoMissing: jobNoMissing ? '1' : '0',
      _recordState: recordState,
    };
    if (source._draftAction) normalizedRow._draftAction = source._draftAction;
    normalizedRow['#'] = index + 1;
    return normalizedRow;
  });
}
